import {
  Directive,
  Input,
  ElementRef,
  OnChanges,
  Renderer2,
  HostListener,
  SimpleChanges,
} from "@angular/core";

@Directive({
  selector: "[appColCount]",
  standalone: true,
})
export class ColCountDirective implements OnChanges {
  @Input("appColCount") colCount: number | [number, number, number] = 1;
  @Input() gap: string = "1rem";

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.onResize();
  }

  @HostListener("window:resize")
  onResize() {
    this.applyColCount();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["colCount"] || changes["gap"]) {
      this.applyColCount();
    }
  }

  private applyColCount() {
    this.renderer.setStyle(this.el.nativeElement, "display", "grid");

    const windowWidth = window.innerWidth;
    const mobileMaxWidth = 768;
    const tabletMaxWidth = 1024;
    let cols: number;

    // If colCount is an array [mobile, tablet, desktop]
    if (Array.isArray(this.colCount)) {
      if (windowWidth <= mobileMaxWidth) {
        cols = this.colCount[0];
      } else if (windowWidth <= tabletMaxWidth) {
        cols = this.colCount[1];
      } else {
        cols = this.colCount[2];
      }
    } else {
      const isMobile = windowWidth <= mobileMaxWidth;
      cols = isMobile ? 1 : this.colCount;
    }

    this.renderer.setStyle(
      this.el.nativeElement,
      "grid-template-columns",
      `repeat(${cols}, 1fr)`
    );

    this.renderer.setStyle(this.el.nativeElement, "--grid-col-count", `${cols}`);
    this.renderer.setStyle(this.el.nativeElement, "gap", this.gap);
  }
}
